<template>
    <div id="generator_histroy">
        <div class="generator_content">历史记录</div>
        <div class="generator_histroy1" v-if="history.length == 0">
            <noData></noData>
        </div>
        <div class="generator_histroy1" ref="scrollContainer" v-else>
            <div :class="historyIndex == i ? 'generator_histroy1_1 generator_histroy1_5' : 'generator_histroy1_1'"
                v-for="(item, i) in history" :key="i" @click="select(i)">
                <div class="generator_histroy1_2">
                    {{ item.title }}
                </div>
                <div class="generator_histroy1_3">
                    <div class="generator_histroy1_4">{{ item.quizTime }}</div>
                    <img src="../assets/image/icon_del.png" @click.stop="del(i)" alt="">
                </div>
            </div>
            <div ref="loader" class="loader">
                <div v-if="loading">加载中...</div>
                <div v-if="!hasMore">没有更多数据了</div>
            </div>
        </div>
        <delPopup ref="delPopup" @confirm="confirm"></delPopup>
    </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus';
import delPopup from './del_popup.vue';
import noData from './no_data.vue';
import api from '@/api/api';
import { scrollerMixin } from '@/mixin/scrollerMixin'
export default {
    mixins: [scrollerMixin],
    components: {
        delPopup, noData
    },
    props: {
        toolsType: {
            type: String,
            default: 'host'
        }
    },
    data() {
        return {
            history: [], //历史记录列表
            historyIndex: null, //选中下标
            delId: null, //删除id
            lastMessageTime: 0, // 上次显示提示信息的时间戳
            formData: {
                typeName: '',//类型名称
                type: ''//类型
            },
        }
    },
    beforeDestroy() {
        this.disconnectObserver();
    },
    watch: {
        // 监听 history 变化，数据加载完成后初始化观察器
        history() {
            this.$nextTick().then(_ => {
                this.initObserver({
                    scrollRequest: () => {
                        this.loadItems()
                    }
                })
            })
        }
    },
    mounted() {
        // this.options.root = this.$refs.scrollContainer
        let listKey = this.toolsType === 'ai' ? 'aiList' : 'labelList'
        let indexKey = this.toolsType === 'ai' ? 'aiIndex' : 'labelIndex'
        let list = JSON.parse(sessionStorage.getItem(listKey))
        let index = sessionStorage.getItem(indexKey)
        if (list && list.length > 0) {

            this.formData = {
                typeName: list[index].name,
                type: list[index].questionType
            }
            this.$nextTick().then(_ => {
                this.initObserver({
                    scrollRequest: () => {
                        this.loadItems()
                    }
                })
                this.loadItems()
            })
        }
    },
    methods: {
        async loadItems() {
            this.loading = true;
            try {
                const response = await api.getHomenovel(this.pageNum, this.formData);
                if (response.code === 200) {
                    this.history = [...this.history, ...response.data];
                    this.pageNum++;
                    this.hasMore = response.data.length >= 20;
                } else {
                    this.$message.warning(response.msg)
                }

            } catch (error) {
                console.error('滚动分页出现问题:', error);
            } finally {
                this.loading = false;
            }
        },
        select(i) {
            this.historyIndex = i
            EventBus.$emit('getHistroy', this.history[i].id)
        },
        del(i) {
            this.delId = i
            // EventBus.$emit('openPrompt', 0)
            this.$refs.delPopup.openPrompt(0)
        },
        confirm() {
            api.delHomenovel({ ids: this.history[this.delId].id }).then((res) => {
                if (res.code == 200) {
                    this.$message.success('删除成功！')
                    this.history.splice(this.delId, 1)
                    this.$refs.delPopup.close()
                }
            })
        },
    }
}
</script>

<style>
#generator_histroy {
    width: 375px;
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 5px 5px 0 0;
}

.generator_histroy1 {
    width: 100%;
    height: calc(100% - 68px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 15px;
    position: relative;
}

.generator_histroy1_1 {
    width: 100%;
    background: #F8F8F8;
    border-radius: 4px;
    padding: 20px;
    font-size: 16px;
    color: #121212;
    margin-bottom: 10px;
}

.generator_histroy1_1:last-child {
    margin-bottom: 0;
}

.generator_histroy1_5 {
    background: var(--tech-btn-Lightblue);
    color: var(--tech-primary);
}

.generator_histroy1_2 {
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    margin-bottom: 10px;
}

.generator_histroy1_3 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    color: #555555;
}

.generator_histroy1_3 img {
    width: 20px;
    height: 20px;
}

.loader {
    padding: 10px;
    text-align: center;
    color: #999;
}
</style>
